import { render } from "./LocalProjects.vue?vue&type=template&id=a6bd310e&scoped=true&ts=true"
import script from "./LocalProjects.vue?vue&type=script&lang=ts"
export * from "./LocalProjects.vue?vue&type=script&lang=ts"

import "./LocalProjects.vue?vue&type=style&index=0&id=a6bd310e&scoped=true&lang=css"
import "./LocalProjects.vue?vue&type=style&index=1&id=a6bd310e&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6bd310e"]])

export default __exports__